module.exports = __webpack_public_path__ + "img/183.c6334a82.jpg";